import React from 'react';
import FormattedDate from './FormattedDate'
import WeatherTemperature from './WeatherTemperature'
import WeatherIcon from './WeatherIcon'
export default function WeatherInfo(props){
    return (
        <div>
             <h1>{props.data.city}</h1>
         <ul>
            <li>
                <FormattedDate date={props.data.date}/>
            </li>
            <li>{props.data.description}</li>
         </ul>
         <div className="row">
            <div className="col-6">
               <WeatherIcon code={props.data.icon} size={52}/>
              
               <WeatherTemperature celsius={props.data.temperature} />
            
            </div>
            <div className="col-6">
                <ul>
                     <li>Humidity: {props.data.humidity}</li>
                     <li>wind: {props.data.wind} km/h</li>
                </ul>
            </div>
        </div>
      </div>
    )

    
}